'use client'
import {useState, useRef, useEffect} from 'react';
import {X} from 'lucide-react';
import MegaMenu from './MegaMenu.jsx';

import styles from '@/ui/header-navigation/MegaMenu.module.scss';
import Box from '@mui/material/Box';
import {BUSINESS_NAME} from "@/content";
import {businessDetails} from "@/content";
import {useTheme} from "@mui/material/styles";
import {useResizeHook} from "@/lib";

const MobileNavigationDrawer = ({
                                    isDrawerOpen,
                                    setIsDrawerOpen,
                                    drawerButtonRef,
                                }) => {
    const [clicked, setClicked] = useState(null);
    const drawerRef = useRef(null);
    const theme = useTheme();
    const {lessThanLaptopS} = useResizeHook()


    const {branding: {headerLogoUrl}} = businessDetails;


    useEffect(() => {
        if (isDrawerOpen && drawerRef.current) {
            // Focus the drawer when it opens
            drawerRef.current.focus();
        }
    }, [isDrawerOpen]);

    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked(null);
        }

        setClicked(index);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            setIsDrawerOpen(false);
            // Focus the drawer button when it closes
            if (drawerButtonRef.current) {
                drawerButtonRef.current.focus();
            }
        }
    };

    return (
        <Box
            className={styles.mobileNavigation}
            ref={drawerRef}
            tabIndex={isDrawerOpen ? 0 : -1}
            onKeyDown={handleKeyDown}
        >
            {isDrawerOpen && (
                <Box
                    className={styles.backdrop}
                    sx={(theme)=>({...theme.custom.headerMobileNav})}
                    onClick={() => {
                        setIsDrawerOpen(false);
                        // Focus the drawer button when it closes
                        if (drawerButtonRef.current) {
                            drawerButtonRef.current.focus();
                        }
                    }}
                ></Box>
            )}

            <Box
                className={`${styles.drawerContent} ${isDrawerOpen ? styles.active : ''}`}
                sx={lessThanLaptopS ? theme.custom.headerMobileDrawerContent : theme.custom.headerDesktopDrawerContent }
            >
                <div className={styles.closeDrawer}>
                    <img src={headerLogoUrl} alt={BUSINESS_NAME} style={{height:'88px'}}/>
                    <button
                        onClick={() => {
                            setIsDrawerOpen(false);
                            // Focus the drawer button when it closes
                            if (drawerButtonRef.current) {
                                drawerButtonRef.current.focus();
                            }
                        }}
                    >
                        <X size={30}  />
                    </button>
                </div>
                <div>
                    <MegaMenu
                        handleToggle={handleToggle}
                        clicked={clicked}
                        setIsDrawerOpen={setIsDrawerOpen}
                    />
                </div>
            </Box>
        </Box>
    );
};

export default MobileNavigationDrawer;
